import { gql } from "@outschool/ui-apollo";

export default gql`
  fragment FollowedUserFragment on FollowedUser {
    uid
    followed_uid
    created_at
    leader {
      uid
      name
      leader_link
      created_at
      photo
      suspended_at
      cityState
      socialOptOut
      details {
        about
        headline
        headlineTranslated
        countryOfResidence
      }
      is_crosslister
      timeZone
      hasAvailabilitySet
      approved
      ownerOfSellerOrg {
        uid
      }
      teacherForSellerOrg {
        uid
        name
      }
      hasBackgroundCheckExpired
    }
  }
`;
